import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import styles from "./Dropdowns.module.css";
import InputHeader from "../input/InputHeader";

// Style reference: https://reactdatepicker.com/

const DateSelect = ({ title, startDate, endDate, onChangeHandler }) => {
  return (
    <>
      <InputHeader text={title} />
      <div className={styles.inputDiv}>
        <DatePicker
          selected={startDate}
          onChange={onChangeHandler}
          startDate={startDate}
          endDate={endDate}
          selectsRange
          inline
          calendarClassName={styles.calendarClassName}
          dayClassName={() => styles.dayClassName}
        />
      </div>
    </>
  );
};

export default DateSelect;
